interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
}

export default function SectionHeading({ index, eyebrow, title, desc }: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="mb-3 flex items-center gap-3">
          <span className="font-heading text-sm font-bold text-primary-500">{index}</span>
          <span className="h-px w-8 bg-primary-300" />
          <span className="text-xs font-medium tracking-[0.22em] text-secondary-600">
            {eyebrow}
          </span>
        </div>
        <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[32px]">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>
        )}
      </div>
    </div>
  );
}